var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { deleteDataFomCollection } from './utils';
const initialState = {
    data: [],
    loading: false,
};
export const fetchOffices = createAsyncThunk('offices/fetchAll', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.assets.fetchAll({ assetType: 'of', page_size: 1000 });
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const createOffice = createAsyncThunk('offices/create', (office_1, _a) => __awaiter(void 0, [office_1, _a], void 0, function* (office, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.assets.create(office);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateoffice = createAsyncThunk('offices/update', (office_1, _a) => __awaiter(void 0, [office_1, _a], void 0, function* (office, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.assets.update(office);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const deleteOffice = createAsyncThunk('offices/delete', (assetId_1, _a) => __awaiter(void 0, [assetId_1, _a], void 0, function* (assetId, { fulfillWithValue, rejectWithValue }) {
    try {
        yield api.assets.delete(assetId);
        return fulfillWithValue(assetId);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const { actions, reducer } = createSlice({
    name: 'offices',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // FETCH OFFICES
        builder.addCase(fetchOffices.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchOffices.fulfilled, (state, { payload }) => {
            state.data = payload.results;
            state.loading = false;
        });
        builder.addCase(fetchOffices.rejected, (state) => {
            state.loading = false;
        });
        // CREATE OFFICE
        builder.addCase(createOffice.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createOffice.fulfilled, (state, { payload }) => {
            state.data = [...state.data, payload];
        });
        builder.addCase(createOffice.rejected, (state) => {
            state.loading = false;
        });
        // UPDATE OFFICE
        builder.addCase(updateoffice.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateoffice.fulfilled, (state, { payload }) => {
            const newData = state.data.map((office) => {
                if (office.id === payload.id) {
                    return payload;
                }
                return office;
            });
            state.data = newData;
        });
        builder.addCase(updateoffice.rejected, (state) => {
            state.loading = false;
        });
        // DELETE OFFICE
        builder.addCase(deleteOffice.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteOffice.fulfilled, (state, { payload }) => {
            state.data = deleteDataFomCollection(state.data, payload);
        });
        builder.addCase(deleteOffice.rejected, (state) => {
            state.loading = false;
        });
    },
});
export default reducer;
